export function slugify (str) {
  return str.split(' ').join('-').toLowerCase()
}

export const stopWords = ['and', 'as', 'at', 'but', 'by', 'even if', 'for', 'from', 'if', 'in', 'into', 'like', 'near', 'now', 'nor', 'of', 'off', 'on', 'on', 'once', 'onto', 'or', 'out of', 'over', 'past', 'so', 'so that', 'than', 'that', 'till', 'to', 'up', 'upon', 'with', 'when', 'yet']

export function unSlugify (str) {
  return str.split('-').map(token => (token.indexOf(stopWords) === -1) ? capitalize(token) : token).join(' ')
}

export function capitalize (str) {
  return str[0].toUpperCase() + str.slice(1, str.length)
}

export const oldTestamentSlug = [
  'genesis',
  'exodus',
  'leviticus',
  'numbers',
  'deuteronomy',
  'joshua',
  'judges',
  'ruth',
  '1-samuel',
  '2-samuel',
  '1-kings',
  '2-kings',
  '1-chronicles',
  '2-chronicles',
  'ezra',
  'nehemiah',
  'esther',
  'job',
  'psalm',
  'proverbs',
  'ecclesiastes',
  'song-of-songs',
  'isaiah',
  'jeremiah',
  'lamentations',
  'ezekiel',
  'daniel',
  'hosea',
  'joel',
  'amos',
  'obadiah',
  'jonah',
  'micah',
  'nahum',
  'habakkuk',
  'zephaniah',
  'haggai',
  'zechariah',
  'malachi'
]

export const newTestamentSlug = [
  'matthew',
  'mark',
  'luke',
  'john',
  'acts',
  'romans',
  '1-corinthians',
  '2-corinthians',
  'galatians',
  'ephesians',
  'philippians',
  'colossians',
  '1-thessalonians',
  '2-thessalonians',
  '1-timothy',
  '2-timothy',
  'titus',
  'philemon',
  'hebrews',
  'james',
  '1-peter',
  '2-peter',
  '1-john',
  '2-john',
  '3-john',
  'jude',
  'revelation'
]

export const booksOfBibleSlugObject = {
  'old': oldTestamentSlug,
  'new': newTestamentSlug
}

export const booksOfBibleSlug = oldTestamentSlug.concat(newTestamentSlug)

export function nextBookOfBible (slug) {
  const index = booksOfBibleSlug.indexOf(slug)
  const nextIndex = (index === booksOfBibleSlug.length -1) ? 0 : index + 1

  const nextSlug = booksOfBibleSlug[nextIndex]

  return {
    slug: nextSlug,
    title: unSlugify(nextSlug)
  }
}

export function whichTestament (bookSlug) {
  const indexInOld = oldTestamentSlug.indexOf(bookSlug)
  const indexInNew = newTestamentSlug.indexOf(bookSlug)

  return indexInOld !== -1 ? 'old' : (indexInNew !== -1 ? 'new' : null)
}

export function hslStringToVector (str) {
  const match = str.match(/^hsl\((\d{1,3}), ?(\d{1,3})%, ?(\d{1,3})%\)/)
  if (!match) return []
  return [match[1], match[2], match[3]]
}

export function hslVectorToString (vec) {
  return `hsl(${vec[0]}, ${vec[1]}%, ${vec[2]}%)`
}



// WEBPACK FOOTER //
// ./src/utils.js